import * as React from "react";
import { cx } from "../../helpers/utils/cx";
import { Typography } from "../Typography";
const clamp = (min, num, max) => Math.min(Math.max(num, min), max);
function renderDefaultLabel(props) {
  const {
    currentPage,
    rowsPerPage,
    totalItems
  } = props;
  const start = rowsPerPage * currentPage + 1;
  const end = clamp(0, rowsPerPage * currentPage + rowsPerPage, totalItems);
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "body-primary",
    fontSize: "text-sm"
  }, start, "-", end, " of ", totalItems);
}
export function PaginationTotalCount(_ref) {
  let {
    currentPage = 0,
    rowsPerPage,
    totalItems,
    renderLabel = renderDefaultLabel
  } = _ref;
  if (!(rowsPerPage && totalItems)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex sm:justify-end sm:flex-1")
  }, renderLabel({
    currentPage,
    rowsPerPage,
    totalItems
  }, renderDefaultLabel));
}